// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-container[data-v-108c52fb]{margin-bottom:-18px}.validators .valid[data-v-108c52fb]{color:var(--v-success-lighten1)}.validators li[data-v-108c52fb]{transition:color .2s;font-weight:500;width:35%;list-style:none;color:var(--v-accentLight-base)}", ""]);
// Exports
module.exports = exports;
